<script>
import Footer from "../../layouts/footer";
import Swal from "sweetalert2";

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

export default {
  components: {Footer },
  data() {
    return {
      certificate: "",
      certificateNotValid: false
    };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  methods: {
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },

    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },

    getCertificate() {
      if (this.certificate === "") {
        Swal.fire({
          title: "",
          icon: "error",
          html: `Field must not be empty`,
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: "OK",
        });
        return;
      }
      axios
        .post("certificate/code", {
          code: this.certificate,
        })
        .then((r) => {
          const { data } = r.data;
          localStorage.setItem("data_certificate", JSON.stringify(data));
          this.$router.push("certificate_valid");
        })
        .catch((err) => {
          this.certificateNotValid = true
        });
    },
  },
};
</script>

<template>
  <div>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <nav
      class="navbar navbar-expand-lg navigation fixed-top sticky"
      id="navbar"
    >
      <div class="container">
        <a class="navbar-logo" href="/">
          <img
            src="@/assets/images/favicon.svg"
            alt
            height="35"
            class="logo logo-dark"
          />
          <img
            src="@/assets/images/favicon.svg"
            alt
            height="35"
            class="logo logo-light"
          />
        </a>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
          data-toggle="collapse"
          data-target="#topnav-menu-content"
          @click="toggleMenu()"
        >
          <img src="@/assets/images/covecoders/icon/menu.png" alt="" />
        </button>

        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul
            class="navbar-nav ml-auto"
            id="topnav-menu"
            v-scroll-spy-active="{ selector: 'a.nav-link' }"
          >
            <li class="nav-item">
              <a class="nav-link" href="/" style="color:#000">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/curriculum" style="color:#000"
                >Curriculum</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/about" style="color:#000">About Us</a>
            </li>
          </ul>

          <div class="ml-lg-2">
            <a href="/registration" class="btn-all w-xs">Join Now</a>
          </div>
        </div>
      </div>
    </nav>
    <div v-scroll-spy>
      <!-- hero section start -->
      <section class="hero-section" id="home">
        <div class="container"></div>
      </section>
      <!-- hero section end -->

      <section class="certificate">
        <div class="container valign">
          <div class="row no-gutters">
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <h3>Verify a certificate</h3>
              <form class="voucher-form">
                <input
                  v-model="certificate"
                  type="text"
                  placeholder="Enter certificate ID"
                  class="form-control"
                />
                <button type="button" @click="getCertificate">Validate</button>
              </form>
              <p style="color:#74CCCF" v-if="!certificateNotValid">
                The Certificate ID can be found at the bottom of each
                certificate.
              </p>
              <p style="color:#EF4651" v-if="certificateNotValid">
                The Certificate ID is <span style="font-weight: bold">invalid</span>
              </p>
            </div>
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <img
                src="@/assets/images/covecoders/hero/certification-pana.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <!-- Footer start -->
      <Footer active-page="certificate"></Footer>
      <!-- Footer end -->
    </div>
  </div>
</template>

<style scoped>
#home {
  width: 100%;
  height: 700px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("https://api.paideia.id/api/files/public/230d122b604b41a7a8e383b1e025736asettingancoverbgcovecoders.png");
}

#after-banner {
  height: 445px;
  padding: 0px 50px 0px 50px;
}

.image-home {
  position: absolute;
  width: 472px;
  height: 446px;
  bottom: -180px;
  z-index: 1;
}

.hero-section .text-wrapper {
  margin-top: -30px;
}

h3 {
  font-family: "PoppinsBold";
  font-size: 40px;
  color: rgb(0, 0, 0);
  line-height: 48px;
  margin-bottom: 10px;
}

#section-form p {
  font-family: "PoppinsSemiBold";
  font-size: 20px;
  color: #000000;
}

#section-form p i {
  font-family: "PoppinsRegular";
  font-size: 14px;
  color: #000000;
}

@media only screen and (max-width: 700px) {
  .image-home {
    top: 40px;
    width: 90vw;
    height: 90vw;
  }

  #section-form .text-wrapper h3 {
    font-size: 28px;
  }

  #section-form p {
    font-size: 15px;
  }

  #home {
    height: auto;
  }

  .hero-section {
    height: auto;
    width: 100%;
  }

  #section-form .row {
    flex-direction: column-reverse;
  }
}

#section-form {
  margin-top: -490px;
}

#section-form .form-label {
  font-family: "PoppinsSemiBold";
  font-size: 20px;
  color: #000000;
}

#section-form .form-label-2 {
  font-family: "PoppinsRegular";
  font-size: 14px;
  color: #2d2d2d;
}

#section-form .form-wrapper {
  margin-left: 0px;
}

#section-form .btn-back {
  font-weight: 600;
  height: 45px;
  line-height: 45px;
  padding: 0px 40px 0px 40px;
  background: #74cccf;
  border: none;
  outline: none;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 42px;
  right: 0;
  top: 0;
  color: #ffffff;
  width: auto;
  font-size: 15px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

#section-form .btn-pay {
  font-weight: 600;
  height: 45px;
  line-height: 45px;
  padding: 0px 25px 0px 25px;
  background: #ed4954;
  border: none;
  outline: none;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 42px;
  right: 0;
  top: 0;
  color: #ffffff;
  width: auto;
  font-size: 15px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

@media only screen and (max-width: 700px) {
  .space-btn {
    margin-top: 10px;
  }
}

.image-regis {
  margin-left: -180px;
}

#section-form tr td .data-client {
  font-family: "PoppinsRegular" !important;
  margin-left: 5px;
}

#section-form tr td .data-client1 {
  font-family: "PoppinsRegular" !important;
}

@media only screen and (max-width: 700px) {
  .image-regis {
    height: auto;
    width: 100%;
    margin: auto;
  }

  #section-form {
    margin-top: -150px;
  }

  #section-form .form-label {
    font-family: "PoppinsSemiBold";
    font-size: 20px;
    color: #000000;
  }

  #section-form .form-label-2 {
    font-family: "PoppinsRegular";
    font-size: 14px;
    color: #2d2d2d;
  }

  #section-form .form-wrapper {
    margin: auto;
  }
}

.font-size-1v {
  font-size: 1vw;
}

.font-size-2v {
  font-size: 2vw;
}

.font-size-3v {
  font-size: 3vw;
}

.font-size-4v {
  font-size: 4vw;
}

.font-size-5v {
  font-size: 5vw;
}

.font-size-6v {
  font-size: 6vw;
}

.commitement-wrap {
  margin: 42px 0px 40px 0px;
}

.commitement-text {
  font-size: 50px;
  letter-spacing: 18px;
}

@media only screen and (max-width: 700px) {
  .commitement-text {
    font-size: 22px;
    letter-spacing: 10px;
  }
}

.flex-footer {
  display: flex;
  justify-content: flex-start;
}

.item {
  margin-right: 20px;
}

.flex-footer img {
  width: 50px;
  height: 50px;
}

.line-bottom {
  margin-top: 120px;
}

.sosmed {
  padding: 0;
  margin-top: -5px;
}

.sosmed li {
  display: inline;
  margin-right: 20px;
}

.sosmed img {
  width: 17px;
}

#topnav-menu-content a:hover {
  font-weight: bold !important;
}

.landing-footer a:hover {
  color: #f49a3a !important;
}

footer p {
  padding: 0px 110px 0px 0px;
}

@media only screen and (max-width: 700px) {
  #topnav-menu-content a:active {
    font-weight: bold !important;
  }

  .landing-footer a:active {
    color: #74cccf !important;
  }

  footer p {
    padding: 0px 0px 0px 0px;
  }
}

.test {
  display: inline-block;
}

.table-custom {
  width: 210px;
}

@media only screen and (max-width: 700px) {
  .table-custom {
    width: 50px;
  }
}

.description-3 img {
  width: 100%;
  height: auto;
}

@media only screen and (max-width: 700px) {
  .table-custom {
    width: 50px;
  }
}

.description-3 {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("https://api.paideia.id/api/files/public/8444ff77beab4fbfaa70f8c7722e23bfVector6.png");
}

#supplementary {
  height: auto;
  padding: 30px 0px 30px 0px;
  margin: 64px 0px 0px 0px;
}

.description-3 p {
  font-family: "PoppinsLight";
  font-size: 25px;
  color: white;
  line-height: 30.5px;
  padding: 0px 50px 0px 0px;
}

.description-3 b {
  font-family: "PoppinsMedium";
}

@media only screen and (max-width: 700px) {
  #supplementary {
    height: auto;
    width: 100%;
    margin: 50px 0px 20px 0px;
    padding: auto;
    background-color: #ef4651;
  }

  .description-3 p {
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 50px;
    padding: 0px 0px 0px 0px;
  }

  .image-place {
    text-align: center;
  }

  .description-3 img {
    width: 80%;
    height: auto;
  }
}

.certificate .voucher-form {
  position: relative;
}

.certificate .voucher-form input {
  height: 60px;
  border: 1px solid #d5d3d3;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 8px;
  color: #292929;
  padding-left: 30px;
  background: #ffffff;
}

.certificate .voucher-form input::placeholder {
  color: #8f8f8f;
}

.certificate .voucher-form button {
  font-weight: 600;
  text-transform: uppercase;
  height: 50px;
  line-height: 40px;
  padding: 0 35px;
  background: #74cccf;
  border-radius: 5px;
  border: none;
  outline: none;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 10px;
  position: absolute;
  right: 5px;
  top: 5px;
  color: #ffffff;
  width: auto;
}

@media (max-width: 575px) {
  .certificate .voucher-form input {
    height: 50px;
    padding-left: 20px;
    font-size: 10px;
  }

  .certificate .voucher-form button {
    line-height: 40px;
    font-size: 10px;
    padding: 0 20px;
    height: 40px;
  }
}

.certificate {
  height: auto;
  width: 100%;
  margin-top: -450px;
}

.certificate h3 {
  font-size: 40px;
  margin-bottom: 100px;
}

.certificate img {
  height: 581px;
  width: auto;
  margin-top: -200px;
}

@media only screen and (max-width: 991px) {
  .certificate {
    height: auto;
    width: 100%;
    margin-top: -500px;
  }

  .certificate img {
    height: auto;
    width: 100%;
    margin: auto;
  }
}

@media only screen and (max-width: 700px) {
  .certificate {
    height: auto;
    width: 100%;
    margin-top: -100px;
  }

  .certificate h3 {
    font-size: 25px;
    margin-bottom: 25px;
  }

  .certificate img {
    height: auto;
    width: 100%;
  }
}

@media (max-width: 575px) {
  .certificate img {
    height: auto;
    width: 100%;
  }
}
</style>
